import httpService from "./http.service";

export function getUserInfo () {
  return httpService.get(`accounts-api/users/me`);
}

export function logout () {
  return httpService.get('accounts-api/logout')
}
